<template>
  <d-container fluid class="main-content-container p-4">
    <d-modal v-if="modalVisible" size="lg" @close="onModalClose">
      <d-modal-header>
        <d-modal-title>Demande de compte marchand</d-modal-title>
      </d-modal-header>
      <d-modal-body>
        <div>
          <b-carousel
            id="carousel-1"
            v-model="slide"
            :interval="0"
            controls
            inner
            background="#00578A"
            img-width="1024"
            img-height="700"
            @sliding-start="onSlideStart"
            @sliding-end="onSlideEnd"
            color="white"
          >
            <b-carousel-slide caption="Informations sur la demande" img-blank img-alt="Blank image"
                              img-blank-color="#00578A">
              <div class="text-white text-left request-status mr-5">
                <p class="mt-5 status-size"> Statut de la demande :
                  <span class="status-color">{{ selectedItem.request_status }}</span>
                </p>
                <b-form-checkbox @change="markRequestAsInProgress" v-model="request_in_progress">
                  <span class="mt-5 request-status">Cochez cette case pour marquer cette demande comme en-cours de
                    traitement pourque l'utilisateur ne puisse plus effectuer de soumission jusqu'à la fin du
                    traitement de sa requête</span>
                </b-form-checkbox>
              </div>
              <div class="text-white text-left mt-4">
                <c-input type="textarea" container-class="mb-3" label="Motif de la demande" v-model="reason" disabled/>
                <c-input type="datetime" container-class="mb-3" label="Date de demande" v-model="created_at" disabled/>
              </div>
            </b-carousel-slide>

            <b-carousel-slide caption="Demande envoyée par" img-blank img-alt="Blank image" img-blank-color="#00578A">
              <div class="text-white text-left  request-status">
                <p class="mt-4 status-size"> Statut du compte :<span class="status-color">{{ account_status }}</span>
                </p>
                <c-input container-class="mb-3" label="Nom de l'utilisateur" v-model="user_name" disabled/>
                <c-input container-class="mb-3" label="Adresse e-mail" v-model="user_email" disabled/>
                <c-input container-class="mb-3" label="Téléphone" v-model="user_phone_number" disabled/>
                <b-form-group>
                  <label class="font-weight-bold mb-0">Pièce d'identité (RECTO)</label>
                  <d-input-group>
                    <d-input-group-addon class="flex-fill" prepend>
                      <d-input-group-text class="w-100">
                        {{ identity_file1_path }}
                      </d-input-group-text>
                    </d-input-group-addon>
                    <d-input-group-addon append>
                      <c-button-spinner variant="info" :fetching="false"
                                        @click="onOpenIDFile(selectedItem.user.kyc.identity_file1_path)"
                                        :disabled="!has_identity_file1_path">
                        <template slot="icon">
                          <i class="fa fa-external-link-alt"></i>
                        </template>
                        Ouvrir
                      </c-button-spinner>
                    </d-input-group-addon>
                  </d-input-group>
                </b-form-group>
                <b-form-group>
                  <label class="font-weight-bold mb-0">Pièce d'identité (VERSO)</label>
                  <d-input-group>
                    <d-input-group-addon class="flex-fill" prepend>
                      <d-input-group-text class="w-100">
                        {{ identity_file2_path }}
                      </d-input-group-text>
                    </d-input-group-addon>
                    <d-input-group-addon append>
                      <c-button-spinner variant="info" :fetching="false"
                                        @click="onOpenIDFile(selectedItem.user.kyc.identity_file2_path)"
                                        :disabled="!has_identity_file2_path">
                        <template slot="icon">
                          <i class="fa fa-external-link-alt"></i>
                        </template>
                        Ouvrir
                      </c-button-spinner>
                    </d-input-group-addon>
                  </d-input-group>
                </b-form-group>
              </div>
            </b-carousel-slide>

            <b-carousel-slide caption="Informations sur l'entreprise" img-blank img-alt="Blank image"
                              img-blank-color="#00578A">
              <div class="text-white text-left mt-4 mb-5">
                <c-input container-class="mb-3" label="Nom de l'entreprise" v-model="enterprise_name" disabled/>
                <b-row>
                  <b-col>
                    <c-input container-class="mb-3" label="Type" v-model="enterprise_status" disabled/>
                  </b-col>
                  <b-col>
                    <c-input container-class="mb-3" label="Forme juridique" v-model="juridic_form" disabled/>
                  </b-col>
                </b-row>
                <div class="text-white text-left">
                  <b-form-group>
                    <label class="font-weight-bold mb-0">Statuts de l'entreprises</label>
                    <d-input-group>
                      <d-input-group-addon class="flex-fill">
                        <d-input-group-text class="w-100">
                          {{ legal_statuses }}
                        </d-input-group-text>
                      </d-input-group-addon>
                      <d-input-group-addon append>
                        <c-button-spinner variant="info" :fetching="false"
                                          @click="onOpenIDFile(selectedItem.legal_statuses)"
                                          :disabled="!has_legal_statuses">
                          <template slot="icon">
                            <i class="fa fa-external-link-alt"></i>
                          </template>
                          Ouvrir
                        </c-button-spinner>
                      </d-input-group-addon>
                    </d-input-group>
                  </b-form-group>
                  <c-input container-class="mb-3" label="Numéro du registre du commerce "
                           v-model="commercial_register_number" disabled/>
                  <b-form-group>
                    <label class="font-weight-bold mb-0">Registre du commerce (Fichier)</label>
                    <d-input-group>
                      <d-input-group-addon class="flex-fill">
                        <d-input-group-text class="w-100">
                          {{ commercial_register }}
                        </d-input-group-text>
                      </d-input-group-addon>
                      <d-input-group-addon append>
                        <c-button-spinner variant="info" :fetching="false"
                                          @click="onOpenIDFile(selectedItem.trade_register)"
                                          :disabled="!has_commercial_register">
                          <template slot="icon">
                            <i class="fa fa-external-link-alt"></i>
                          </template>
                          Ouvrir
                        </c-button-spinner>
                      </d-input-group-addon>
                    </d-input-group>
                  </b-form-group>
                  <c-input container-class="mb-3" label="Numéro du contribuable " v-model="taxpayer_no" disabled/>
                </div>
              </div>
            </b-carousel-slide>

            <b-carousel-slide caption="Informations sur l'entreprise" img-blank img-alt="Blank image"
                              img-blank-color="#00578A"
                              v-if="selectedItem.type === 'ENTREPRISE'">
              <div class="text-white text-left">
                <b-form-group>
                  <label class="font-weight-bold mb-0">Contribuable (Fichier)</label>
                  <d-input-group>
                    <d-input-group-addon class="flex-fill" taxpayer>
                      <d-input-group-text class="w-100">
                        {{ taxpayer }}
                      </d-input-group-text>
                    </d-input-group-addon>
                    <d-input-group-addon append>
                      <c-button-spinner variant="info" :fetching="false"
                                        @click="onOpenIDFile(selectedItem.taxpayer)"
                                        :disabled="!has_tax_payer">
                        <template slot="icon">
                          <i class="fa fa-external-link-alt"></i>
                        </template>
                        Ouvrir
                      </c-button-spinner>
                    </d-input-group-addon>
                  </d-input-group>
                </b-form-group>
                <c-input container-class="mb-3" label="Téléphone" v-model="enterprise_phone" disabled/>
                <c-input container-class="mb-3" label="Email" v-model="enterprise_email" disabled/>
                <c-input container-class="mb-3" label="Adresse" v-model="enterprise_address" disabled/>
                <c-input container-class="mb-3" label="Boite postal" v-model="enterprise_post_box" disabled/>
                <b-row>
                  <b-col>
                    <c-input container-class="mb-3" label="Région" v-model="enterprise_region" disabled/>
                  </b-col>
                  <b-col>
                    <c-input container-class="mb-3" label="Ville" v-model="enterprise_town" disabled/>
                  </b-col>
                </b-row>
              </div>
            </b-carousel-slide>

            <b-carousel-slide caption="Informations sur le représentant légal" img-blank img-blank-color="#00578A"
                              img-alt="Blank image" v-if="selectedItem.type !== 'PARTICULIER'">
              <div class="text-white text-left request-status">
                <c-input container-class="mb-3" label="Nom du représentant" v-model="legal_representative_name"
                         disabled/>
                <c-input container-class="mb-3" label="Adresse e-mail" v-model="legal_representative_phone" disabled/>
                <c-input container-class="mb-3" label="Téléphone" v-model="legal_representative_email" disabled/>
                <b-form-group>
                  <label class="font-weight-bold mb-0">Identité du représentant</label>
                  <d-input-group>
                    <d-input-group-addon class="flex-fill" prepend>
                      <d-input-group-text class="w-100">
                        {{ legal_representative_identity }}
                      </d-input-group-text>
                    </d-input-group-addon>
                    <d-input-group-addon append>
                      <c-button-spinner variant="info" :fetching="false"
                                        @click="onOpenIDFile(selectedItem.legal_rep_identity)"
                                        :disabled="!has_legal_representative_identity">
                        <template slot="icon">
                          <i class="fa fa-external-link-alt"></i>
                        </template>
                        Ouvrir
                      </c-button-spinner>
                    </d-input-group-addon>
                  </d-input-group>
                </b-form-group>
                <b-form-group>
                  <label class="font-weight-bold mb-0">Acte désignant le réprésentant légal</label>
                  <d-input-group>
                    <d-input-group-addon class="flex-fill" prepend>
                      <d-input-group-text class="w-100">
                        {{ legal_representative_act }}
                      </d-input-group-text>
                    </d-input-group-addon>
                    <d-input-group-addon append>
                      <c-button-spinner variant="info" :fetching="false"
                                        @click="onOpenIDFile(selectedItem.legal_rep_act)"
                                        :disabled="!has_legal_representative_act">
                        <template slot="icon">
                          <i class="fa fa-external-link-alt"></i>
                        </template>
                        Ouvrir
                      </c-button-spinner>
                    </d-input-group-addon>
                  </d-input-group>
                </b-form-group>
              </div>
            </b-carousel-slide>

            <b-carousel-slide caption="Informations sur les bénéficiaires" img-blank img-alt="Blank image"
                              img-blank-color="#00578A" v-if="selectedItem.type !== 'PARTICULIER'">
              <div class="text-white text-left request-status mr-5 mt-5">
                <b-form-group>
                  <label class="font-weight-bold mb-0">Bénéficiaire 1</label>
                  <d-input-group>
                    <d-input-group-addon class="flex-fill" prepend>
                      <d-input-group-text class="w-100">
                        {{ effective_beneficiary_1 }}
                      </d-input-group-text>
                    </d-input-group-addon>
                    <d-input-group-addon append>
                      <c-button-spinner variant="info" :fetching="false"
                                        @click="onOpenIDFile(selectedItem.effective_beneficiary_1)"
                                        :disabled="!has_effective_beneficiary_1">
                        <template slot="icon">
                          <i class="fa fa-external-link-alt"></i>
                        </template>
                        Ouvrir
                      </c-button-spinner>
                    </d-input-group-addon>
                  </d-input-group>
                </b-form-group>
                <b-form-group>
                  <label class="font-weight-bold mb-0">Bénéficiaire 2 </label>
                  <d-input-group>
                    <d-input-group-addon class="flex-fill" prepend>
                      <d-input-group-text class="w-100">
                        {{ effective_beneficiary_2 }}
                      </d-input-group-text>
                    </d-input-group-addon>
                    <d-input-group-addon append>
                      <c-button-spinner variant="info" :fetching="false"
                                        @click="onOpenIDFile(selectedItem.effective_beneficiary_2)"
                                        :disabled="!has_effective_beneficiary_2">
                        <template slot="icon">
                          <i class="fa fa-external-link-alt"></i>
                        </template>
                        Ouvrir
                      </c-button-spinner>
                    </d-input-group-addon>
                  </d-input-group>
                </b-form-group>
                <b-form-group>
                  <label class="font-weight-bold mb-0">Bénéficiaire 3</label>
                  <d-input-group>
                    <d-input-group-addon class="flex-fill" prepend>
                      <d-input-group-text class="w-100">
                        {{ effective_beneficiary_3 }}
                      </d-input-group-text>
                    </d-input-group-addon>
                    <d-input-group-addon append>
                      <c-button-spinner variant="info" :fetching="false"
                                        @click="onOpenIDFile(selectedItem.effective_beneficiary_3)"
                                        :disabled="!has_effective_beneficiary_3">
                        <template slot="icon">
                          <i class="fa fa-external-link-alt"></i>
                        </template>
                        Ouvrir
                      </c-button-spinner>
                    </d-input-group-addon>
                  </d-input-group>
                </b-form-group>
              </div>
            </b-carousel-slide>

            <b-carousel-slide caption="Informations de virement" img-blank img-alt="Blank image"
                              img-blank-color="#00578A">
              <div class="text-white text-left mt-5 mb-5">
                <c-input container-class="mb-3" label="Numéro master sim" v-model="master_sim_number" disabled/>
                <b-form-group>
                  <label class="font-weight-bold mb-0">RIB</label>
                  <d-input-group>
                    <d-input-group-addon class="flex-fill">
                      <d-input-group-text class="w-100">
                        {{ rib }}
                      </d-input-group-text>
                    </d-input-group-addon>
                    <d-input-group-addon append>
                      <c-button-spinner variant="info" :fetching="false"
                                        @click="onOpenIDFile(selectedItem.RIB)" :disabled="!has_rib_file">
                        <template slot="icon">
                          <i class="fa fa-external-link-alt"></i>
                        </template>
                        Ouvrir
                      </c-button-spinner>
                    </d-input-group-addon>
                  </d-input-group>
                </b-form-group>
              </div>
            </b-carousel-slide>

            <b-carousel-slide caption="Contacts de référence" img-blank img-alt="Blank image"
                              img-blank-color="#00578A" v-if="selectedItem.type !== 'PARTICULIER'">
              <div class="text-white text-left request-status mt-3 mb-5">
                <div>
                  <p class="text-before-line">Contacts de référence 1</p>
                  <hr/>
                  <b-row>
                    <b-col>
                      <c-input container-class="mb-3" label="Noms et prénoms" v-model="contact_name_1" disabled/>
                    </b-col>
                    <b-col>
                      <c-input container-class="mb-3" label="Téléphone" v-model="contact_phone_1" disabled/>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <c-input container-class="mb-3" label="Adresse e-mail" v-model="contact_email_1" disabled/>
                    </b-col>
                    <b-col>
                      <c-input container-class="mb-3" label="Function" v-model="contact_function_1" disabled/>
                    </b-col>
                  </b-row>
                </div>
                <div class="mt-3 request-status">
                  <b-button block v-b-toggle.reference-2 variant="primary">Contacts de référence 2</b-button>
                  <b-collapse id="reference-2" accordion="reference" role="tabpanel">
                    <b-row>
                      <b-col>
                        <c-input container-class="mb-3" label="Noms et prénoms" v-model="contact_name_2" disabled/>
                      </b-col>
                      <b-col>
                        <c-input container-class="mb-3" label="Téléphone" v-model="contact_phone_2" disabled/>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col>
                        <c-input container-class="mb-3" label="Adresse e-mail" v-model="contact_email_2" disabled/>
                      </b-col>
                      <b-col>
                        <c-input container-class="mb-3" label="Function" v-model="contact_function_2" disabled/>
                      </b-col>
                    </b-row>
                  </b-collapse>
                </div>
                <div class="mt-3 request-status">
                  <b-button block v-b-toggle.reference-3 variant="primary">Contacts de référence 3</b-button>
                  <b-collapse id="reference-3" accordion="reference-3" role="tabpanel">
                    <b-row>
                      <b-col>
                        <c-input container-class="mb-3" label="Noms et prénoms" v-model="contact_name_3" disabled/>
                      </b-col>
                      <b-col>
                        <c-input container-class="mb-3" label="Téléphone" v-model="contact_phone_3" disabled/>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col>
                        <c-input container-class="mb-3" label="Adresse e-mail" v-model="contact_email_3" disabled/>
                      </b-col>
                      <b-col>
                        <c-input container-class="mb-3" label="Function" v-model="contact_function_3" disabled/>
                      </b-col>
                    </b-row>
                  </b-collapse>
                </div>
              </div>
            </b-carousel-slide>

            <b-carousel-slide caption="Validation de la requête" img-blank img-alt="Blank image"
                              img-blank-color="#00578A">
              <div class="text-white text-left request-status mt-5">
                <c-input type="textarea" container-class="mb-3" label="Commentaire ( A remplir uniquement si la
                  demande est rejetée et énumérez les erreurs à corriger)" v-model="comment"/>
                <d-form-checkbox v-model="treated">
                  Demande validée
                </d-form-checkbox>
                <c-input type="datetime" container-class="mb-3" label="Traitée le" v-model="treated_at" disabled/>
              </div>
            </b-carousel-slide>
          </b-carousel>
        </div>
      </d-modal-body>
      <d-modal-footer class="justify-content-center">
        <c-button-spinner variant="success" :fetching="fetchingFormSubmit" @click="onFormSubmit">
          <template slot="icon">
            <i class="fa fa-save"></i>
          </template>
          Enregistrer
        </c-button-spinner>
        <b-button variant="secondary" @click="onModalClose" class="ml-2">
          <i class="fa fa-times"></i> Fermer
        </b-button>
      </d-modal-footer>
    </d-modal>
    <d-card class="card-small">
      <d-card-header class="px-4 pb-0">
        <d-input-group class="justify-content-center">
          <c-input class="w-25" placeholder="Utilisateur ou entreprise..." v-model="search"/>
          <c-button-spinner class="inline-btn ml-1" variant="primary" :fetching="fetchingSearch"
                            @click="onSearchSubmit">
            <template slot="icon"><i class="fa fa-search"></i></template>
            Rechercher
          </c-button-spinner>
        </d-input-group>
      </d-card-header>
      <d-card-body class="pt-0">
        <c-table :fetching="fetchingData" :table-data="filteredData" :fields="fields" :actions="actions" :per-page="25">
          <p class="text-center" slot="empty">Aucune demande de compte marchand.</p>
        </c-table>
      </d-card-body>
    </d-card>
  </d-container>
</template>

<script>
import {Api, getFilename, Toast, truncate, truncateLeft} from '../../helpers'

export default {
  title: "Demandes de compte marchand",
  data() {
    return {
      //SLIDER VARIABLES
      slide: 0,
      sliding: null,

      search: '',
      fetchingSearch: false,

      fetchingData: false,
      data: [],

      //table header
      fields: [
        {key: 'user_name', label: 'Utilisateur', sortable: true},
        {key: 'enterprise_name_pretty', label: 'Entreprise', sortable: true},
        {key: 'juridic_form', label: 'Forme jur.', sortable: true},
        {key: 'type', label: 'Type de compte', sortable: true},
        {key: 'created_at_pretty', label: 'Envoyée le', sortable: true},
        {key: 'updated_at_pretty', label: 'Modifiée le', sortable: true},
        {key: 'status', label: 'Statut', sortable: true},
        {key: 'actions', label: 'Actions'},
      ],

      actions: [
        {type: 'white', icon: 'fa fa-ellipsis-h', title: "Détails du compte", handler: this.onItemSelect}
      ],

      modalVisible: false,
      selectedItem: null,

      submitted: false,
      fetchingFormSubmit: false,

      user_name: "",
      user_email: "",
      user_phone_number: "",
      account_status: '',

      legal_representative_name: '',
      legal_representative_phone: '',
      legal_representative_email: '',

      reason: "",
      created_at: "",
      comment: "",
      treated_at: "",
      treated: false,

      enterprise_name: '',
      enterprise_status: '',
      juridic_form: '',
      enterprise_phone: '',
      enterprise_email: '',
      enterprise_address: '',
      enterprise_post_box: '',
      enterprise_region: '',
      enterprise_town: '',

      taxpayer_no: '',
      master_sim_number: '',
      contact_name_1: '',
      contact_phone_1: '',
      contact_email_1: '',
      contact_function_1: '',

      contact_name_2: '',
      contact_phone_2: '',
      contact_email_2: '',
      contact_function_2: '',

      contact_name_3: '',
      contact_phone_3: '',
      contact_email_3: '',
      contact_function_3: '',

      request_in_progress: false

    }
  },
  computed: {
    filteredData() {
      const search = this.search.toLowerCase()
      return this.data
        .filter(item => {
          const user = item.user
          return (item.social_denomination || '').toLowerCase().includes(search)
            || (item.juridic_form || '').toLowerCase().includes(search)
            || item.type.toLowerCase().includes(search)
            || (user.first_name + ' ' + user.last_name).toLowerCase().includes(search)
            || user.username.toLowerCase().includes(search)
            || (user.phone_number || '').includes(search)
            || (user.email || '').includes(search)
        })
    },
    itemSelected() {
      return !!this.selectedItem
    },

    has_identity_file1_path() {
      return this.selectedItem.user.kyc ? this.selectedItem.user.kyc.identity_file1_path : ""
    },
    identity_file1_path() {
      return this.has_identity_file1_path ? truncateLeft(getFilename(
        this.selectedItem.user.kyc ? this.selectedItem.user.kyc.identity_file1_path : ""),
        32) : '-- Aucun fichier --'
    },

    has_identity_file2_path() {
      return this.selectedItem.user.kyc ? this.selectedItem.user.kyc.identity_file2_path : ""
    },
    identity_file2_path() {
      return this.has_identity_file2_path ? truncateLeft(getFilename(
        this.selectedItem.user.kyc ? this.selectedItem.user.kyc.identity_file2_path : ""),
        32) : '-- Aucun fichier --'
    },

    has_legal_statuses() {
      return this.selectedItem.legal_statuses
    },
    legal_statuses() {
      return this.has_legal_statuses ? truncateLeft(getFilename(this.selectedItem.legal_statuses), 32)
        : '-- Aucun fichier --'
    },

    has_commercial_register() {
      return this.selectedItem.trade_register
    },
    commercial_register() {
      return this.has_commercial_register ? truncateLeft(getFilename(this.selectedItem.trade_register), 32)
        : '-- Aucun fichier --'
    },

    has_tax_payer() {
      return this.selectedItem.trade_register
    },
    taxpayer() {
      return this.has_tax_payer ? truncateLeft(getFilename(this.selectedItem.taxpayer), 32) :
        '-- Aucun fichier --'
    },
    has_effective_beneficiary_1() {
      return this.selectedItem.effective_beneficiary_1
    },
    effective_beneficiary_1() {
      return this.has_effective_beneficiary_1 ? truncateLeft(getFilename(this.selectedItem.effective_beneficiary_1),
        32) : '-- Aucun fichier --'
    },

    has_effective_beneficiary_2() {
      return this.selectedItem.effective_beneficiary_2
    },
    effective_beneficiary_2() {
      return this.has_effective_beneficiary_2 ? truncateLeft(getFilename(this.selectedItem.effective_beneficiary_2),
        32) : '-- Aucun fichier --'
    },

    has_effective_beneficiary_3() {
      return this.selectedItem.effective_beneficiary_3
    },
    effective_beneficiary_3() {
      return this.has_effective_beneficiary_3 ? truncateLeft(getFilename(this.selectedItem.effective_beneficiary_3),
        32) : '-- Aucun fichier --'
    },

    has_legal_representative_identity() {
      return this.selectedItem.legal_rep_identity
    },
    legal_representative_identity() {
      return this.has_legal_representative_identity ? truncateLeft(getFilename(this.selectedItem.legal_rep_identity),
        32) : '-- Aucun fichier --'
    },

    has_legal_representative_act() {
      return this.selectedItem.legal_rep_act
    },
    legal_representative_act() {
      return this.has_legal_representative_act ? truncateLeft(getFilename(this.selectedItem.legal_rep_act),
        32) : '-- Aucun fichier --'
    },

    has_rib_file() {
      return this.selectedItem.RIB
    },
    rib() {
      return this.has_rib_file ? truncateLeft(getFilename(this.selectedItem.RIB), 32) : '-- Aucun fichier --'
    },
  },
  created() {
    this.fetchingData = true
    Api.get('/merchant/account_request/list')
      .then(res => {
        this.data = res.data.requests.map(this.mapItem)
      })
      .catch(err => this.error = err)
      .then(() => this.fetchingData = false)
  },

  methods: {

    onSlideStart(slide) {
      this.sliding = true
    },
    onSlideEnd(slide) {
      this.sliding = false
    },
    mapItem(item) {
      let type = ''
      if (item.status == "PARTICULAR") {
        type = "PARTICULIER"
      } else if (item.status == "ENTERPRISE") {
        type = "ENTREPRISE"
      } else {
        type = "STARTUP"
      }
      return {
        ...item,
        enterprise_name_pretty: truncate(item.social_denomination, 20),
        user_name: truncate(item.user.first_name + ' ' + item.user.last_name, 20) + (item.user.verified ? " ✔" : ""),
        field_of_work_pretty: truncate(item.field_of_work, 20),
        monthly_revenue: item.transaction_volume_per_month,
        created_at_pretty: item.created_at.replace(' ', '\n'),
        updated_at_pretty: item.updated_at.replace(' ', '\n'),
        status: item.treated ? "Traitée" : "En attente...",
        statusVariant: item.treated ? "secondary" : "warning",
        type
      }
    },
    onItemSelect(item) {
      this.selectedItem = item
      this.modalVisible = true

      this.treated = item.treated
      this.user_name = item.user.first_name + ' ' + item.user.last_name + (item.user.verified ? " ✔" : "")
      this.user_email = item.user.email
      this.user_phone_number = item.user.phone_number
      this.reason = item.request_reason
      this.created_at = item.created_at
      this.comment = item.comment
      this.treated_at = item.treated_at
      this.treated = item.treated

      this.enterprise_name = item.social_denomination
      this.enterprise_status = item.type
      this.juridic_form = item.juridic_form
      this.enterprise_address = item.address
      this.enterprise_post_box = item.postal_address
      this.enterprise_region = item.region
      this.enterprise_town = item.town
      this.enterprise_phone = item.phone_number
      this.enterprise_email = item.email,
        this.master_sim_number = item.master_sim_number

      item.comment !== null ? this.comment = item.comment : this.comment = ""
      item.user.verified === true ? this.account_status = "VERIFIÉ" : this.account_status = "NON VERIFIÉ"
      item.request_status == "EN COURS" ? this.request_in_progress = true : this.request_in_progress = false

      if (item.type !== "PARTICULIER") {
        this.legal_representative_name = item.legal_rep_name
        this.legal_representative_phone = item.legal_rep_phone
        this.legal_representative_email = item.legal_rep_email
        this.commercial_register_number = item.trade_register_no
        this.taxpayer_no = item.taxpayer_no

        this.contact_name_1 = item.contact_name_1
        this.contact_phone_1 = item.contact_phone_1
        this.contact_email_1 = item.contact_email_1
        this.contact_function_1 = item.contact_function_1

        this.contact_name_1 = item.contact_name_2
        this.contact_phone_1 = item.contact_phone_2
        this.contact_email_1 = item.contact_email_2
        this.contact_function_1 = item.contact_function_2

        this.contact_name_1 = item.contact_name_3
        this.contact_phone_1 = item.contact_phone_3
        this.contact_email_1 = item.contact_email_3
        this.contact_function_1 = item.contact_function_3
      }

    },

    onOpenIDFile(key) {
      window.open(key, '_blank')
    },
    clearFields() {
      this.comment = ''
      this.treated = false
      this.request_in_progress = false
    },
    onModalClose() {
      this.modalVisible = false
      this.submitted = false
      this.selectedItem = null
      this.clearFields()
    },
    isFormValid() {
      return true
    },
    onFormSubmit() {
      this.submitted = true
      if (!this.isFormValid()) return
      this.fetchingFormSubmit = true

      Api.postFormData('/merchant/account_request/update', {
        request_id: this.selectedItem.id,
        comment: this.comment,
        treated: this.treated,
      })
        .then(res => {
          const request = this.mapItem(res.data.request)
          this.data = this.data.replaceOne(item => item.id === this.selectedItem.id, request)

          this.onModalClose()

          Toast.success(`La demande de "${request.user_name}" a été mise à jour avec succès !`)
        })
        .catch(err => this.error = err)
        .then(() => this.fetchingFormSubmit = false)
    },

    markRequestAsInProgress() {
      if (this.request_in_progress === false) {
        this.submitted = true

        Api.postFormData('/merchant/account_request/toggle_treatment', {
          request_id: this.selectedItem.id,
        })
          .then(res => {
            const request = this.mapItem(res.data.request)
            this.data = this.data.replaceOne(item => item.id === this.selectedItem.id, request)

            Toast.success(`La demande de "${request.user_name}" est passée à en-cours de traitement !`)
          })
          .catch(err => this.error = err)
          .then(() => this.fetchingFormSubmit = false)
      }
    },

    onSearchSubmit() {
      this.fetchingSearch = true
      Api.postFormData('/merchant/account_request/find', {search: this.search})
        .then(res => this.data = res.data.requests.map(this.mapItem))
        .catch(err => this.error = err)
        .then(() => this.fetchingSearch = false)
    },
  }
}

</script>

<style scoped>
hr {
  margin-top: -25px;
  background-color: gray;
  height: 3px;
}

.text-before-line {
  font-weight: bold;
  font-size: 20px;
  color: white;
  text-align: center;
}

.request-status {
  font-weight: bold;
}

.status-color {
  color: #3CBE0A;
}

.status-size {
  font-size: 16px;
}
</style>

<style>
/* the modification of the carousel property in a scoped style doesn't work*/
.carousel-caption h3 {
  color: darkgray !important;
  bottom: 20px !important;
  top: 25px !important;
}

.carousel-caption {
  top: 0px !important;
}
</style>
